
<template lang="pug">
QContextMenuMod.context-menu(ref="contextMenu")
  q-list(
    highlight
    v-close-overlay
  )
    q-item(
      v-for="option of options"
      :key="option.label"
      @click.native="option.onClick"
    )
      q-item-side.context-menu-item-side(
        v-if="option.check != null"
        :icon="option.check ? 'check' : ''"
      )
      q-item-main
        q-item-tile {{option.label}}
</template>

<script>
import QContextMenuMod from 'components/QContextMenuMod'

export default {
  components: {QContextMenuMod},

  data() {
    return {
      options: [],
    }
  },

  methods: {
    show(e, options) {
      this.options = options
      this.$refs.contextMenu.show(e)
    },
  },
}
</script>

<style lang="sass">
.context-menu
  user-select: none
  // min-width: 100px

.context-menu-item-side
  width: 24px
  min-width: 24px
</style>
